import { render, staticRenderFns } from "./CustomersPendingProductsBatch.vue?vue&type=template&id=30062b46&"
import script from "./CustomersPendingProductsBatch.vue?vue&type=script&lang=js&"
export * from "./CustomersPendingProductsBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30062b46')) {
      api.createRecord('30062b46', component.options)
    } else {
      api.reload('30062b46', component.options)
    }
    module.hot.accept("./CustomersPendingProductsBatch.vue?vue&type=template&id=30062b46&", function () {
      api.rerender('30062b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomersPendingProductsBatch.vue"
export default component.exports